import { Fragment, useEffect, useState } from "react";
import style from "./article-carousel.module.css";
import Image from "next/image";
import Carousel from "react-elastic-carousel";
import Link from "next/link";
import { useQuery } from "@apollo/client";
import { GetArticles } from "@/graphql/query/articles";
import parse from "html-react-parser";
function ArticleCarousel({ articleList }) {
  const noArrow = ({ type, onClick, isEdge }) => {
    return <Fragment></Fragment>;
  };
  const noPaginate = ({ pages, activePage, onClick }) => {
    return <Fragment></Fragment>;
  };

  return (
    <Fragment>
      <div className={style.articles_carousel_container}>
          <Carousel renderArrow={noArrow}>
            {articleList.map((article) => (
              <Link key={article.id} href={`/articles/${article.slug}`}>
                <a>
                  <div className={style.article_card}>
                    <div className={style.image_wrapper}>
                      <Image
                        src={article.imageUrl}
                        layout="fill"
                      />
                    </div>
                    <div className={style.content}>
                      <h4>{article.heading}</h4>
                      <p>{article.description}</p>
                    </div>
                  </div>
                </a>
              </Link>
            ))}
          </Carousel>
        </div>
    </Fragment>
  );
}
export default function ArticleCarouselContainer() {
  const { data:articles, error } = useQuery(GetArticles, {
    variables: {
      categorySlug: "หมีรักบ้าน",
      limit: 3
    },
  });
  const [articleList, setArticleList] = useState();
  useEffect(() => {
    if (!articles) return

    const articleContentFormat = (content) => {
      if (!content) return ''

      const htmlStrip = /(<[^>]*>|\&nbsp|\&ldquo|\&rdquo|;)/ig
      return content.replace(htmlStrip, '')?.substring(0, 250) + '...'
    }
    const _articles = articles.getArticles.articles.map((obj) => ({
      id: obj.id,
      imageUrl: obj.thumbnail,
      title: obj.title,
      heading: obj.title,
      description: articleContentFormat(obj.description_body),
      slug: obj.slug
    }));

    setArticleList(_articles);
  }, [articles]);
  return (
    <Fragment>
      {articleList && <ArticleCarousel articleList={articleList} />}
    </Fragment>
  );
}
